import store from '@/store/store';

export function NonAuthGuard (to, from, next) {
    if (!store.getters['session/loggedIn']) {
        next();
        return;
    }

    next({ name: 'Hospitals' });
}